module.exports = __webpack_public_path__ + "static/media/icon-facebook.c0a50ecd.png";